<template>
  <div class="wrapper">
    <router-link :to="{name: 'GameDetailsStarChaser'}">
      <a-row id="star-chaser" type="flex" justify="space-around" align="top">
        <a-col :sm="{span: 12}" :lg="{span: 8}" class="game-description">
          <h1>Star Chaser</h1>
          <p>
            An experienced explorer is sent into the vast space to find all kind of minerals and life species.
            Unfortunately he gets trapped in a asteroids ring wich is used as garbage disposal
          </p>
          <p>Your mission is to helpp him to scape and help him avoid all this obstacles and survive this asteroids hell.</p>
        </a-col>
        <a-col :sm="{span: 12}" :lg="{span: 12}">
          <img
            src="../../assets/images/starchaser/in_game.png"
            alt="star chaser"
            class="game-image"
          />
        </a-col>
      </a-row>
    </router-link>

    <a-row id="flamy" type="flex" justify="space-around" align="top">
      <a-col :sm="{span: 12, span: 12}" :lg="{span: 10}">
        <img src="../../assets/images/flamy/in_game.png" alt="flamy's light" class="game-image" />
      </a-col>
      <a-col :sm="{span: 12}" :lg="{span: 10}" class="game-description">
        <h1>Flamy's Light</h1>
        <p>Young flamy is lost in darkness searching for her inner light, guide her in her journey.</p>
        <p>
          This is the history of a young girl who has a problem of anxiety and depression. To be able to overcome this she has created a whole new world,
          trough this world she will be able to fix and solve a lot of problems that are happening in her town.
        </p>
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.wrapper {
  font-family: "ZCOOL QingKe HuangYou", cursive;
  font-size: 14pt;
}

#star-chaser {
  margin-top: 3em;
}

.game-description {
  color: #595959;
}

#flamy {
  margin-top: 3em;
}

.game-image {
  width: 100%;
  max-width: 700px;

  max-height: 500px;
}
</style>
